/* eslint-disable max-lines */
import { all, call, put } from 'redux-saga/effects'

import routes, { Router } from '../../routes'
import i18n from '../../i18n'
import { app } from '../../configuration'
import { actions as appActions } from '../../redux/app/redux'


export default class ThankyouSagas {

  static* init() {
    return yield call(ThankyouSagas.setupSeo)
  }

  static* setupSeo() {
    yield put(
      appActions.setSeo({
        title: i18n.t('SEO_thankyou_title'),
        description: i18n.t('SEO_thankyou_description'),
        keywords: i18n.t('SEO_thankyou_keywords'),
        url: `${app.APP_URL}${Router.getRouteUrl(routes.thankyou)}`,
        noindex: false,
      })
    )
  }

  static* loop() {
    yield all([
      //
    ])
  }

}
